import React, { Component } from 'react'
import { Invites, } from '../../components/Users'
import firebase from 'firebase'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as invitesActionCreators from '../../redux/modules/invites'
import { db } from '../../config/firebaseconfig'

class InvitesContainer extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const inviteId = this.props.match.params.inviteId
    this.props.fetchingInvitation()
    db.collection('userInvites').doc(inviteId).get()
      .then((doc) => {
        if (doc.exists) {
          const invite = doc.data()
          
          this.props.fetchingInvitationSuccess(doc.data())
          this.props.fetchingIsStudent()
          db.collection('students').doc(invite.userId).get()
            .then((studentDoc) => {
              if (studentDoc.exists) {
                this.props.fetchingIsStudentSuccess(true)
              } else {
                this.props.fetchingIsStudentSuccess(false)
              }
            })
            .catch((err) => this.props.fetchingIsStudentError(err)) 
        } else {
          this.props.fetchingInvitationError('Invite not found.')
        }
      })
      .catch((err) => this.props.fetchingInvitationError(err))

  }

  render() {
    console.log('rendering invites container')
    return (
      <Invites 
        isFetchingInvitation={this.props.isFetchingInvitation}
        isFetchingInvitationError={this.props.isFetchingInvitationError}
        invitation={this.props.invitation}
        saving={this.props.saving}
        savingSuccess={this.props.savingSuccess}
        savingError={this.props.savingError}
        isSaving={this.props.isSaving}
        isSavingError={this.props.isSavingError}
        isStudent={this.props.isStudent}
        isFetchingIsStudent={this.props.isFetchingIsStudent}
        isFetchingIsStudentError={this.props.isFetchingIsStudentError}
        history={this.props.history}
      />
    )
  }
}

export default connect(
  (state) => ({
    isSaving: state.invites.isSaving,
    isSavingError: state.invites.isSavingError,
    isFetchingInvitation: state.invites.isFetchingInvitation,
    isFetchingInvitationError: state.invites.isFetchingInvitationError,
    invitation: state.invites.invitation,
    isStudent: state.invites.isStudent,
    isFetchingIsStudent: state.invites.isFetchingIsStudent,
    isFetchingIsStudentError: state.invites.isFetchingIsStudentError,
    isFetchingIsStudentErrorContent: state.invites.isFetchingIsStudentErrorContent,
  }),
  (dispatch) => bindActionCreators(invitesActionCreators, dispatch)
)(InvitesContainer)


// WEBPACK FOOTER //
// ./src/containers/Users/InvitesContainer.js